/* eslint-disable @typescript-eslint/indent */
import { IWebBanner } from '@/interfaces/homePage';
import { createContext } from 'react';

type NotificationContextType = {
  data?: {
    notification?: IWebBanner;
    banner?: IWebBanner[];
  };
  setData: React.Dispatch<
    React.SetStateAction<{
      notification?: IWebBanner | undefined;
      banner?: IWebBanner[] | undefined;
    }>
  >;
  notificationState: boolean;
  setNotificationState: React.Dispatch<React.SetStateAction<boolean>>;
};

const notificationState = {
  data: undefined,
  setData: () => null,
  notificationState: false,
  setNotificationState: () => null,
};
const NotificationContext = createContext<NotificationContextType>(notificationState);

export default NotificationContext;
